export const SOHM_CONTRACT_ADDRESS = '0x04906695D6D12CF5459975d7C3C03356E4Ccd460';
export const GOHM_CONTRACT_ADDRESS = '0x0ab87046fBb341D058F17CBC4c1133F25a20a52f';

export enum Adornment {
    Ohm = 'OHM',
    SOhm = 'sOHM',
    GOhm = 'gOHM',
    Percentage = '%',
    Dollar = '$',
}
